import { contentUrl } from '../api'

export const SAFETY_PROFILE = {
  name: 'SAFETY_PROFILE Screen',
  title: 'SAFETY_PROFILE',
  mobileType: "mobile",
  content: [
    {
      menuTemplate: 'SINGLE',
      menuName: 'ADVERSE EVENTS FROM CLINICAL TRIALS',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${contentUrl}/safety-profile/safety_aes_clinical_desktop@2x.png`, alt: "Safety AES Clinical Trials" }],
          mobileImageList: [{ srcMobile: `${contentUrl}/safety-profile/safety_aes_clinical_mobile@2x.png`, alt: "Safety AES Clinical Trials" }],
        },
      }
    },
    {
      menuTemplate: 'SINGLE',
      menuName: 'LONG-TERM SAFETY PROFILE',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${contentUrl}/safety-profile/safety_longterm_desktop@2x.png`, alt: "Long Term Safety Profile" }],
          mobileImageList: [{ srcMobile: `${contentUrl}/safety-profile/safety_longterm_mobile@2x.png`, alt: "Long Term Safety Profile" }],
        },
      }
    },
    {
      menuTemplate: 'TEXT',
      menuName: 'References',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${contentUrl}/safety-profile/safety_references_desktop@2x.png`, alt: "Safety Profile References" }],
          mobileImageList: [{ srcMobile: `${contentUrl}/safety-profile/safety_references_mobile@2x.png`, alt: "Safety Profile References" }],
        },
      }
    },
  ],
}
